var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * BeoButton is custom made Button component.
 *
 * @author rajeev.k
 * @description This component is an extension of PrimeReact Button tag (<Button/>).
 * All properties of PrimeReact Button can be used by this BeoButton component.
 * interface BeoButtonProps are defined to create custom buttons easily with an extra property buttontype
 * Interface ButtonModesInt is used to  access different button modes defined in ButtonModes
 */
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import { NavLink } from "react-router-dom";
import { useBEOController } from "@context/BeoContext";
var BeoButton = function (_a) {
    var _b;
    var _c = _a.buttontype, buttontype = _c === void 0 ? {
        category: "normal", // Default value for category
        imageOrIcon: "",
        badgeType: null,
        badgeText: null,
        route: "",
        key: "",
    } : _c, nested = _a.nested, ref = _a.ref, props = __rest(_a, ["buttontype", "nested", "ref"]);
    var controller = useBEOController()[0];
    if (buttontype.category === "normal") {
        return _jsx(Button, __assign({}, props, { ref: ref, pt: {
                root: {
                    className: "transition duration-300 ease-in-out hover:scale-105 hover:shadow-lg",
                },
            } }));
    }
    if (buttontype.category === "normal_with_badge" &&
        buttontype.badgeType !== null) {
        return (_jsx(BeoButton, __assign({}, props, { ref: ref, children: _jsx(Badge, { value: buttontype.badgeText, severity: buttontype.badgeType }) })));
    }
    if (buttontype.category === "image" && buttontype.imageOrIcon !== "") {
        return (_jsx(BeoButton, __assign({}, props, { ref: ref, style: {
                backgroundImage: "url(/images/".concat(controller.theme, "/").concat(buttontype.imageOrIcon, ".png)"),
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                width: "0px",
            } })));
    }
    if (buttontype.category === "icon_with_badge" &&
        buttontype.imageOrIcon !== "") {
        return (_jsx(BeoButton, __assign({ ref: ref }, props, { icon: buttontype.imageOrIcon, children: _jsx(Badge, { value: buttontype.badgeText, severity: buttontype.badgeType }) })));
    }
    if (buttontype.category === "icon_without_badge" &&
        buttontype.imageOrIcon !== "") {
        return (_jsx(BeoButton, __assign({ ref: ref, size: "small" }, props, { icon: buttontype.imageOrIcon, label: buttontype.label, className: "\n        px-4 py-2\n        rounded-lg\n        shadow-lg\n        transition-all\n        duration-200\n        ease-in-out\n        hover:bg-opacity-80\n        disabled:opacity-50\n        flex flex-row\n        items-center\n        content-center\n        justify-center\n        ".concat(nested ? "text-sm h-7 " : "", "\n        ").concat((_b = props.className) !== null && _b !== void 0 ? _b : "", "\n      "), outlined: nested ? true : props.outlined })));
    }
    if (buttontype.category === "nav_button") {
        return (_jsx(NavLink, { to: buttontype.route ? buttontype.route : "", style: { flex: 1 }, children: _jsx(BeoButton, __assign({ ref: ref, link: true }, props)) }, buttontype.key));
    }
    return _jsx(_Fragment, { children: "this type button not available" });
};
export default BeoButton;
